// querySelector is an interface for anything that implements the querySelector method in a generic way
interface querySelector {
    querySelector<T>(selector: string): T;
}

export function Clone(selector: string | HTMLTemplateElement, parent: querySelector = document): HTMLElement {
    if (!(selector instanceof HTMLTemplateElement)) {
        selector = parent.querySelector<HTMLTemplateElement>(selector);
    }

    return selector.content.cloneNode(true) as HTMLElement;
}